import { render } from "./EmailBoasVindas.vue?vue&type=template&id=e1fd9aa6"
import script from "./EmailBoasVindas.vue?vue&type=script&lang=js"
export * from "./EmailBoasVindas.vue?vue&type=script&lang=js"

import "./EmailBoasVindas.vue?vue&type=style&index=0&id=e1fd9aa6&lang=css"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__